export default {
	PRODUCT_NAME: 'Data Quality',
	FABRIC_API_WAREHOUSE_SCOPE: 'https://api.fabric.microsoft.com/Warehouse.Read.All',
	FABRIC_API_WORKSPACE_SCOPE: 'https://api.fabric.microsoft.com/Workspace.Read.All',
	FABRIC_REGISTRATION_SETUP_PAGE: 'https://marketplace-stage.informatica.com/registerFabric',
	FABRIC_BE_SERVICE_URI: import.meta.env.VITE_BE_WORKLOAD_SERVICE_URI,
	EXTERNAL_URI: 'core.externalURIs',
	WORKLOAD_NAME_PARAM: '__infa_wname',
	FABRIC_ACTIONS: {
		ARTIFACT_ALREADY_EXISTS: 'artifact-already-exists',
		OPEN_DATA_SOURCE_SELECTION_VIEW: 'open.data_source_selection',
		OPEN_DEV_ONLY: 'open.dev_only',
		OPEN_UTILITIES_PAGE: 'open.utilities_page',
		OPEN_CREATE_DIALOG: 'open.create_dialog',
	},
};
